module.exports = __webpack_public_path__ + "static/3-9c1446243b1620c1db578d487079900d.png";